// 文档 AI 抽取的全局任务态（纯前端 Redux）。
// 状态放在顶层 → 浮动按钮与抽屉都读它；抽屉关闭不丢 result，可由浮动按钮再次打开。
import {
  AI_EXTRACTION_START,
  AI_EXTRACTION_DONE,
  AI_EXTRACTION_ERROR,
  AI_EXTRACTION_OPEN_DRAWER,
  AI_EXTRACTION_CLOSE_DRAWER,
  AI_EXTRACTION_RESET,
} from '../actions/AiExtraction';

const INIT_STATE = {
  status: 'idle',     // idle | processing | done | error
  jobId: null,
  moduleId: null,
  result: null,       // { property, contacts, contactTypeOptions }
  error: '',
  drawerOpen: false,
};

const AiExtractionReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case AI_EXTRACTION_START:
      // 开新任务：进入处理中，显示浮动按钮；此刻不开抽屉（完成后才自动弹出）
      return {
        ...INIT_STATE,
        status: 'processing',
        jobId: action.payload.jobId,
        moduleId: action.payload.moduleId,
      };
    case AI_EXTRACTION_DONE:
      return { ...state, status: 'done', result: action.payload, error: '', drawerOpen: true };
    case AI_EXTRACTION_ERROR:
      return { ...state, status: 'error', error: action.payload, drawerOpen: false };
    case AI_EXTRACTION_OPEN_DRAWER:
      return { ...state, drawerOpen: true };
    case AI_EXTRACTION_CLOSE_DRAWER:
      // 只关抽屉，不清结果 → 浮动按钮还能再打开
      return { ...state, drawerOpen: false };
    case AI_EXTRACTION_RESET:
      return { ...INIT_STATE };
    default:
      return state;
  }
};

export default AiExtractionReducer;
